export default {
      id: "generate-statements-usage",
      viewBox: "0 0 160 159.58",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#generate-statements",
      toString: function () {
        return this.url;
      }
    }